import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import PerfilAlumnoModal from "../../navigation/academy/perfilAlumnoModal";

export interface AccionesAlumnoProps {
	studentId: number;
	campusId: number;
	/** En tarjetas de teléfono los botones van a la izquierda; en tabla, pegados a la derecha. */
	alinear?: "inicio" | "fin";
}

/**
 * "Ver perfil" y "Finanzas" con las mismas pastillas del módulo Estudiantes (waAccionFila),
 * para que en Estudiantes por Aprobar y en Pagos por Procesar se vean y se usen igual
 * (Esteban, 2026-09-23). El clic no sube a la fila: la fila abre la solicitud o el ticket.
 */
const AccionesAlumno: React.FC<AccionesAlumnoProps> = ({ studentId, campusId, alinear }) => {
	const navigate = useNavigate();
	//El perfil se abre en ventana, sin salir de la pantalla; Finanzas sí es otra pantalla, como en Estudiantes.
	const [viendo, setViendo] = useState<boolean>(false);
	return (
		<div className="waAcciones" style={alinear === "inicio" ? { justifyContent: "flex-start" } : undefined} onClick={(e) => e.stopPropagation()}>
			<button type="button" className="waAccionFila principal" onClick={() => setViendo(true)}>Ver Perfil</button>
			<button type="button" className="waAccionFila" onClick={() => navigate(`/statement?alumno=${studentId}&plantel=${campusId}`)}>Finanzas</button>
			{viendo ? <PerfilAlumnoModal studentId={studentId} campusId={campusId} onClose={() => setViendo(false)} /> : ""}
		</div>
	);
};

export default AccionesAlumno;
